import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import { ObjectGraph } from '@jet/environment/dependencies';
import type { PageHeader, PageKind } from '@jet-app/music-classical/models';
import type {
    ClassicalAPIResponse,
    ClassicalAPIResponseHeader,
    ClassicalListViewPage,
} from '@jet-app/music-classical/api/types';
import { transformListView } from '@jet-app/music-classical/utilities/transforms/list-view';
import type { LibraryListPage } from '@jet-app/music-classical/models/pages/library/list';
import { makePageHeader } from '../../common/page-header';

export function renderLibraryListPage(
    canonicalURL: string,
    apiResponse: ClassicalAPIResponse,
    objectGraph: ObjectGraph,
): LibraryListPage {
    const responseBody = apiResponse?.body as ClassicalListViewPage;
    const responseHeader = (responseBody?.header ||
        {}) as unknown as ClassicalAPIResponseHeader;

    const page = {
        pageKind: responseBody?.type as unknown as PageKind,
        kind: 'LibraryListPage',
        header: makePageHeader(responseHeader, objectGraph),
        sections: [
            transformListView(apiResponse?.body as ClassicalListViewPage),
        ],
        canonicalURL,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.libraryListPage,
        ),
    };

    page.header.entities = page.sections?.[0].items?.map((item) => {
        return {
            id: item.id,
            type: item.type,
            inFavorites: item.inFavorites,
            inLibrary: true,
        };
    });

    return page;
}
